import * as Html from "../util/Html.ts";
import * as amplify from "../util/amplify.ts";
import {EventStore} from "../server/EventStore.js";

export {init,destroy}
Html.registerWidget('widget/minievent',{init:init,destroy:destroy})

var node;
async function display(){
  var calendarIds = (await EventStore.getSelectedCalendarIds()).filter(id=>!id.startsWith("calendarTask/"))
  EventStore.loadEventsBySync(calendarIds,[],{start:new Date(),end:new Date(new Date().getTime()+3600000*24*60)}).then(events=>{
    events.sort((a,b)=>a.start-b.start)
    import("../widget/minievent.mustache").then(function(TPL){
      Html.setHtml(node,TPL,{feed:events.slice(0,4)});
    });
  })
  
}

function init(container){
  node = container;
  if(container.is(':visible')) {
    display();
    amplify.subscribe("eventCreated eventUpdated eventDeleted",display);        
  }
}
function destroy(){
  amplify.unsubscribe("eventCreated eventUpdated eventDeleted",display);
}
